var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 14.8001V17.2001M7.40039 18.4001H14.6004M3.80039 14.8001H18.2004C19.5259 14.8001 20.6004 13.7256 20.6004 12.4001V4.0001C20.6004 2.67461 19.5259 1.6001 18.2004 1.6001H3.80039C2.47491 1.6001 1.40039 2.67461 1.40039 4.0001V12.4001C1.40039 13.7256 2.47491 14.8001 3.80039 14.8001Z",
    stroke: "#455468",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.885dc42b1f99619ad37aa9e3b7f6e2c1.svg";
export { ForwardRef as ReactComponent };